import React from "react";
import "../Style/Header.scss";
import Navber from "./Navber";
import Text from "./Text";


const Header = () => {
  return (
    <>
      <Navber />
      <Text/>
     
    </>
  );
};

export default Header;
